import { ClientEvents } from 'common/events/ClientEvents';
import React, { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MealPlanSubscriptionContext } from 'src/pages/consumer/meal-plans/MealPlanSubscriptionsContext';
import shefBagWithHeart from 'src/pages/consumer/meal-plans/upcoming-order/assets/shefBagWithHeart.svg';
import { getDateCopy } from 'src/pages/consumer/meal-plans/upcoming-order/utils/getDateCopy';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Routes } from 'src/shared/Routes';
import { Icon } from 'web-common/src/shared/design-system/components/Icon';
import { DishFirstExploreWidthLimit } from '../../../SharedStyles';

export const ExistingSubscriberBanner: React.FC = () => {
  const tracker = useTracker();
  const [currentUser] = useCurrentUser();
  const { mealPlan } = useContext(MealPlanSubscriptionContext);
  const history = useHistory();

  const onClick = () => {
    tracker.track(ClientEvents.EXPLORE_MEAL_PLAN_HERO_BANNER_EXISTING_SUB_CLICK, {
      userId: currentUser?.id,
      currentUserLastSearchedZipCode: currentUser?.lastSearchedZipCode,
    });
    history.push(Routes.CONSUMER_MEAL_PLANS_UPCOMING_ORDER);
  };

  useEffect(() => {
    tracker.track(ClientEvents.EXPLORE_MEAL_PLAN_HERO_BANNER_EXISTING_SUB_SHOWN, {
      userId: currentUser?.id,
      currentUserLastSearchedZipCode: currentUser?.lastSearchedZipCode,
    });
  }, [currentUser?.id, currentUser?.lastSearchedZipCode, tracker]);

  return (
    <div className='bg-raspberry'>
      <DishFirstExploreWidthLimit>
        <div className='p-4'>
          <p className='mb-2 text-base font-semibold text-white'>👋🏼 Welcome back, {currentUser?.firstName}!</p>
          <button className='size-full rounded-lg bg-white p-4' onClick={onClick}>
            <span className='flex size-full gap-4 max-md:items-center'>
              <img className='h-11' src={shefBagWithHeart} alt='' />
              <span className='w-full items-center justify-between max-md:flex-col md:flex'>
                <span className='block text-left'>
                  <span className='mb-1 w-auto rounded-lg bg-eggplant px-2 py-1 text-sm font-semibold text-white'>
                    {getDateCopy(new Date(mealPlan?.nextDeliveryDate ?? ''))}
                  </span>
                  <span className='mb-0 mt-1 block text-lg font-bold text-neutral-800'>Your upcoming delivery</span>
                </span>
                <span className='flex items-center gap-1'>
                  <Link className='text-base text-neutral-700 underline' to={Routes.CONSUMER_MEAL_PLANS_UPCOMING_ORDER}>
                    manage order
                  </Link>
                  <Icon name='chevronRight' />
                </span>
              </span>
            </span>
          </button>
        </div>
      </DishFirstExploreWidthLimit>
    </div>
  );
};
